module.exports = __webpack_public_path__ + "img/sca.a219f007.png";